import { Outlet, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { AppHeader } from "@/render/components/AppHeader";
import { CompendiumTabs } from "./CompendiumTabs";

// The Compendium layout: the shared header (no board actions) and the sub-nav tab strip above an Outlet for
// the Compendium's pages (the Overview landing and each Article). One home for the Compendium chrome, so the header
// and tabs render once for every Compendium surface rather than per page. The board view mounts the same
// AppHeader directly, with its action cluster in the slot.
export function CompendiumLayout() {
  const navigate = useNavigate();
  const onNavigate = useCallback(
    (to: string) => navigate({ to } as Parameters<typeof navigate>[0]),
    [navigate],
  );
  return (
    <div className="app">
      <AppHeader onNavigate={onNavigate} />
      <CompendiumTabs />
      <Outlet />
    </div>
  );
}
